import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const SiteImagesCtx = createContext(null);

export const SiteImagesProvider = ({ children }) => {
  const [images, setImages] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/site-images")
      .then((r) => setImages(r.data || {}))
      .catch(() => setImages({}))
      .finally(() => setLoaded(true));
  }, []);

  const updateImage = useCallback(async (key, url) => {
    const { data } = await api.patch(`/admin/site-images/${key}`, { url });
    setImages((prev) => ({ ...prev, [key]: data.url }));
    return data.url;
  }, []);

  return (
    <SiteImagesCtx.Provider value={{ images, loaded, updateImage }}>
      {children}
    </SiteImagesCtx.Provider>
  );
};

export const useSiteImages = () => {
  const ctx = useContext(SiteImagesCtx);
  if (!ctx) throw new Error("useSiteImages must be used inside SiteImagesProvider");
  return ctx;
};
